export default [
  {
    path: '/i2-sales',
    name: 'I2Sales',
    component: () => import('@/views/I2Sales/Index.vue'),
    meta: {
      pageTitle: 'İkinci El Satışlar',
      breadcrumb: [
        {
          text: 'İkinci El Satışlar',
          active: true,
        },
      ],
      resource: 'RP_SALE_I2SALES',
      action: 'read',
    },
  },
  {
    path: '/i2-sales/brands',
    name: 'I2SalesBrands',
    component: () => import('@/views/I2Sales/Brands.vue'),
    meta: {
      pageTitle: 'İkinci El Satışlar',
      breadcrumb: [
        {
          text: 'Anlık Satışlar',
          active: true,
        },
      ],
      resource: 'RP_SALE_I2SALES',
      action: 'read',
    },
  },
  {
    path: '/i2-sales/cumulatives',
    name: 'I2SaleCumulatives',
    component: () => import('@/views/I2Sales/Cumulatives.vue'),
    meta: {
      pageTitle: 'İkinci El Satışlar',
      breadcrumb: [
        {
          text: 'Kümülatif',
          active: true,
        },
      ],
      resource: 'RP_SALE_I2SALES',
      action: 'read',
    },
  },
  {
    path: '/i2-sales/buy-types',
    name: 'I2BuyTypes',
    component: () => import('@/views/I2Sales/BuyTypes.vue'),
    meta: {
      pageTitle: 'İkinci El Satışlar',
      breadcrumb: [
        {
          text: 'Rac - Takas - Dış Alım',
          active: true,
        },
      ],
      resource: 'RP_SALE_I2SALES',
      action: 'read',
    },
  },
  {
    path: '/i2-sales/swaps',
    name: 'I2Swaps',
    component: () => import('@/views/I2Sales/SwapSales.vue'),
    meta: {
      pageTitle: 'İkinci El Satışlar',
      breadcrumb: [
        {
          text: 'Takaslar',
          active: true,
        },
      ],
      resource: 'RP_SALE_I2SALES',
      action: 'read',
    },
  },
]
